export default "__VITE_ASSET__E0lYXMVs__"